var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8478 4.24716C10.8478 6.5928 8.94632 8.49432 6.60068 8.49432C4.25503 8.49432 2.35352 6.5928 2.35352 4.24716C2.35352 1.90152 4.25503 0 6.60068 0C8.94632 0 10.8478 1.90152 10.8478 4.24716Z",
    fill: "#092C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9576 11.7056C12.6531 10.914 11.9899 10.3262 10.5815 10.3262H6.60018H2.61943C0.3142 10.3262 0 11.8977 0 13.3642V17.45H9.65123C9.54604 17.0603 9.48475 16.6532 9.48475 16.2306C9.48475 14.0661 10.9609 12.2442 12.9578 11.7057L12.9576 11.7056Z",
    fill: "#092C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1779 12.4629C12.0966 12.4629 10.4102 14.15 10.4102 16.2306C10.4102 18.312 12.0966 19.9991 14.1779 19.9991C16.2592 19.9991 17.9456 18.312 17.9456 16.2306C17.9456 14.15 16.2586 12.4629 14.1779 12.4629ZM14.1632 18.1822C14.0845 18.2764 13.9684 18.3313 13.8451 18.3326H13.8413C13.7199 18.3326 13.6038 18.2797 13.5245 18.188L11.798 16.2034L12.4317 15.6525L13.835 17.2655L16.1349 14.5139L16.7794 15.0526L14.1632 18.1822Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmentIcon);
export default __webpack_public_path__ + "static/media/RecruitmentIcon.242511ed58c166e2a9e6424f962680e1.svg";
export { ForwardRef as ReactComponent };